module.exports = __webpack_public_path__ + "static/media/caf_not_found.70c3466f.png";